module.exports = __webpack_public_path__ + "img/box_pro_six_3.2441e0d7.jpg";